var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "section",
    attrs: {
      "id": "firebaseui-auth-container"
    }
  });

}
var staticRenderFns = []

export { render, staticRenderFns }